import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .new-colaborator-container {
    display: flex;
    flex-wrap: wrap;

    padding: 20px 0px;

    width: 70%;

    gap: 4px 24px;
  }

  .new-colaborator-container-access {
    display: flex;
    flex-wrap: wrap;

    padding: 20px 0px;

    width: 70%;

    gap: 24px;
  }

  .new-colaborator-title {
    color: #000;

    margin-bottom: 20px;

    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .new-colaborator-subtitle {
    display: flex;
    align-items: center;

    gap: 16px;
    margin-bottom: 20px;

    new-colaborator-subtitle-img {
      width: 16px;
      height: 16px;
    }

    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }

  .review {
    display: flex;
    gap: 15px;
  }

  .new-colaborator-toggle {
    width: 250px;

    margin-bottom: 28px;
  }
`
